<template>
    <div class="form-input-wrapper">
        <label class="form-label" for="checklist">
            <span>{{label}}</span>
        </label>
        <div class="checklist-items-wrapper">
            <div v-for="(item,key) in checklist" :key="key" class="checklist-item existing-item">
                <div class="task-svg-title-wrapper">
                    <div class="task-checkbox-container">
                        <!-- spinner koji se aktivira na klik i traje dok se ne izvrsi update -->
                        <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
                        </svg>

                        <div :class="['task-checkbox', 'popup-check', 'chk-'+key, item.finished ? 'active' : '']" @click="handleCheckClick(item, key)">
                            <div class="check"></div>
                        </div>
                    </div>
                    <span :id="'span-id-'+key" @dblclick="startEdit(key)">{{item.task_name}}</span>
                    <input @keyup.enter="saveChange(key)" @blur="saveChange(key)" :id="'edit-id-'+key" style="display:none;" class="new-checkitem-input " type="text" :placeholder="placeholder" v-model="checklist[key].task_name" />
                </div>
                <div
                    class="remove-checklist-item"
                    @click="deleteSubtask(item)"
                >
                    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z" fill="#70707E"/>
                    </svg>
                </div>
            </div>
            <div class="checklist-item new-checkitem" @click="addNewItem" @keyup.enter="addNewItem">
                <div class="add-napomena add-button add-checkitem">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                        <g>
                        <g>
                            <path fill="#0acab1"
                            d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                        </g>
                        </g>
                    </svg>
                </div>
                <input class="new-checkitem-input" type="text" :placeholder="placeholder" id="checklist" v-model="current_item" />
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap';
import $ from 'jquery';
export default {
    props:["label", "placeholder"],
    data() {
        return {
            checklist:[],
            current_item:""
        }
    },
    methods: {
        addNewItem(){
            if (this.current_item != "") {
                this.checklist.push({task_name:this.current_item, finished:false});
                this.current_item = "";
            }
        },
        deleteSubtask(it){
            this.checklist = this.checklist.filter((item)=>item != it);
        },
        async handleCheckClick(event){
            event.finished = !event.finished;
        },
        startEdit(key){
            gsap.to("#edit-id-"+key, 0, {display:'flex'})
            gsap.to("#span-id-"+key, 0, {display:'none'})
            $("#edit-id-"+key).focus()
        },
        saveChange(key){
            gsap.to("#edit-id-"+key, 0, {display:'none'})
            gsap.to("#span-id-"+key, 0, {display:'flex'})
        }
    },
}
</script>